export const emailRegEx =
  /^(?!.*@.*@)(?=.{1,64}@)[A-Za-zА-Яа-я0-9_+-]+(\.[A-Za-zА-Яа-я0-9_+-]+)*@[^-][A-Za-zА-Яа-я0-9-]+(\.[A-Za-zА-Яа-я0-9-]+)*(\.[A-Za-zА-Яа-я]{2,})$/;
